import React from 'react';
import { Box, Typography } from '@mui/material';
import { Button } from 'antd';

const FollowupQuestions = ({ questions, onQuestionClick }) => {
    if (!questions || questions.length === 0) return null;

    return (
        <Box sx={{ mt: 2 }}>
            <Typography variant="subtitle1" sx={{ mb: 1, fontSize: '20px', fontWeight: 'bold' }}>
                Follow-up Questions:
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
                {questions.map((question, index) => (
                    <Button
                        style={{ width: 'fit-content', borderRadius: 4 }}
                        type="default"
                        key={index}
                        // size="small"
                        onClick={() => onQuestionClick(question)}
                        // sx={{ alignSelf: 'flex-start', textTransform: 'none', textAlign: 'left' }}
                    >
                        {question}
                    </Button>
                ))}
            </Box>
        </Box>
    );
};

export default FollowupQuestions;
